/**
 * The main api service
 */
import http from '@util/http';
import { incubator } from '@api/req';

export async function queryIncCustomList(params) {
  return http.get(incubator.CUSTOM_LIST, params);
}

export async function queryExportIncCustomList(params) {
  return http.download(incubator.CUSTOM_LIST_EXPORT, params, '客户导出.xlsx');
}

export async function queryIncCustomInfo(params) {
  return http.get(incubator.CUSTOM_INFO, params);
}

export async function queryIncCustomSettled(params) {
  return http.get(incubator.CUSTOM_SETTLED, params);
}

export async function queryIncCustomSettledSign(params) {
  return http.get(incubator.CUSTOM_SETTLED_SIGN, params);
}

export async function queryIncCustomBusinessSettled(params) {
  return http.get(incubator.CUSTOM_BUSINESS_SETTLED, params);
}

export async function queryIncCustomBusinessOregistapp(params) {
  return http.get(incubator.CUSTOM_BUSINESS_OREGISTAPP, params);
}

export async function queryIncCustomProject(params) {
  return http.get(incubator.CUSTOM_PROJECT, params);
}

export async function queryIncCustomIncomeList(params) {
  return http.get(incubator.CUSTOM_INCOME_LIST, params);
}

export async function queryIncCustomIncomeUnconfirm(params) {
  return http.get(incubator.CUSTOM_INCOME_UNCONFIRMED, params);
}

export async function queryIncCustomPayableToBeTurns(params) {
  return http.get(incubator.CUSTOM_PAYABLE_TOBETURNS, params);
}

export async function queryCustomCanMoveOut(params) {
  return http.get(incubator.CUSTOM_CAN_MOVEOUT, params);
}

export async function queryCustomMoveOut(params) {
  return http.post(incubator.CUSTOM_MOVEOUT, params);
}

export async function queryCustomMoveOutRemind(params) {
  return http.get(incubator.CUSTOM_MOVEOUT_REMIND, params);
}

export async function queryCustomMoveOutOverdue(params) {
  return http.get(incubator.CUSTOM_MOVEOUT_OVERDUE, params);
}

export async function queryPayablePending(params) {
  return http.get(incubator.CUSTOM_PENDING, params);
}

export async function queryPayablePaid(params) {
  return http.get(incubator.CUSTOM_PAID, params);
}

export async function queryPayablePaidDeposit(params) {
  return http.get(incubator.CUSTOM_PAID_DEPOSIT, params);
}

export async function queryPayablePaidLiquidate(params) {
  return http.get(incubator.CUSTOM_PAID_LIQUIDATE, params);
}

export async function queryPayablePaidTurn(params) {
  return http.get(incubator.CUSTOM_PAID_TURN, params);
}

export async function queryPayablePaidTodo(params) {
  return http.get(incubator.CUSTOM_PAID_TODO, params);
}

export async function queryPayableObsolete(params) {
  return http.get(incubator.CUSTOM_OBSOLETE, params);
}

export async function queryPayablePendingRefund(params) {
  return http.get(incubator.CUSTOM_PENDINGREFUND, params);
}

export async function queryPayableRefunded(params) {
  return http.get(incubator.CUSTOM_REFUND, params);
}

export async function queryPayableDetailStatistics(params) {
  return http.get(incubator.CUSTOM_PAYABLE_DETAIL_STATIS, params);
}

export async function queryPayableStatistics(params) {
  return http.get(incubator.CUSTOM_PAYABLE_STATIS, params);
}

export async function queryIncuBusinessSigning(params) {
  return http.get(incubator.CUSTOM_SIGNING, params);
}

export async function queryIncuBusinessArchving(params) {
  return http.get(incubator.CUSTOM_ARCHIVING, params);
}

export async function queryIncuBusinessArchved(params) {
  return http.get(incubator.CUSTOM_ARCHIVIED, params);
}



// WEBPACK FOOTER //
// ./src/api/incubator/custom.js